
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signIn/passwordRecovery",
      function () {
        return require("private-next-pages/signIn/passwordRecovery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signIn/passwordRecovery"])
      });
    }
  